import { ADMIN_SETTINGS, READ_ALERTS_API } from "../helpers/api-path";
import httpClient from "./http.interceptor";

const readAlertsAPI = async (formData) => {
    const URL = READ_ALERTS_API + "?environment=" + process.env.REACT_APP_ENVIRONMENT;
    return await httpClient.post(URL, { ...formData })
}

const getAlertsAPI = async (formData) => {
    return await httpClient.get(ADMIN_SETTINGS, {
        params: {
            ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
            limit: formData.limit,
            lastKey: formData.lastKey,
            type: "ALERTS",
        }
    })
}

export {
    readAlertsAPI,
    getAlertsAPI
}